// src/components/billing/cardGrid.js — the ONE grid the plans screen lays its cards out in.
//
// ⭐ 2026-10-08: plan cards (PlanGrid) and pack cards (PacksPanel) share it, so they wrap the same way at every
// window width. Before, packs used a narrower minimum (220px vs 260px) and a smaller gap: on a narrow window a plan
// card took the full row while a pack card took half of it.
export const CARD_GRID = {
  display: 'grid', gap: 16,
  gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))',
};
